import { useEffect, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Queries
import getAddresses from '../Queries/getAddresses';
import postActualizarDomicilio from '../Queries/postActualizarDomicilio';

// Components
import Alert from '../Alert';

// Styles
import styles from './index.module.sass';

export default function SavedAddresses({
  history,
  orderData,
  setOrderData,
  screenSize,
  getCookie,
  webservice,
  getOrder,
  setOpenAddress,
  setLoaddingAddress,
  addressSelected,
  setAddressSelected,
  setSessionMessage,
  callback,
  extraShippingharge,
}) {
  const [loading, setLoading] = useState(false);
  const [addresses, setAddresses] = useState([]);
  const [clientAddresses, setClientAddresses] = useState([]);
  const [alertText, setAlertText] = useState('');
  const [alertOpen, setalertOpen] = useState(false);

  const { t } = useTranslation(['global', 'address']);

  const getAddressesFunction = useCallback(
    async (action, cat, id, quantity, lineNum, neddLoading) => {
      setLoading(true);
      const response = await getAddresses({
        jsonBody: { kitCode: getCookie('usuarioOk') },
      });

      const {
        getAddvresult = [],
        typeMessage = '',
        message = '',
      } = response?.getAddressResult || {};

      setSessionMessage(message);

      if (typeMessage !== 'Success') {
        return null;
      }

      for (let i = 0; i < getAddvresult.length; i++) {
        const { finalClient = '' } = getAddvresult[i];

        if (finalClient.toUpperCase() === 'S') {
          setClientAddresses((oldArray) => {
            return [...oldArray, getAddvresult[i]];
          });
        } else {
          setAddresses((oldArray) => {
            return [...oldArray, getAddvresult[i]];
          });
        }
      }
      setLoading(false);
    },
    [getCookie, setSessionMessage],
  );

  async function handleSelect(newAddress) {
    setLoading(true);
    setLoaddingAddress(true);
    console.log(newAddress);
    const domicilioEnvio = {
      estado: '',
      ocurre: extraShippingharge ? 1 : 0,

      soloPaqueteria: 0,

      colonia: newAddress?.suburb || '',
      paqueteria: newAddress?.suburb === 'PR' ? newAddress?.packaging || 'FEDEX' : 'FEDEX',

      calle: newAddress?.address || '',
      municipio: newAddress?.municipality || '',
      cp: newAddress?.postalCode || '',
      numeroExterior: newAddress?.outdoorNum || '',
      numeroInterior: newAddress?.interiorNum || '',
      entreCalle: newAddress.betweenStr || '',
      yCalle: newAddress?.andStreet || '',
      //dominio: window.location.hostname,

      domicilioClienteFinalSN: newAddress.finalClient,
      domicilioClienteFinalNombre: newAddress?.endCustName || '',
      domicilioClienteFinalTelefono: newAddress?.endCustTel || '',
      omitirValidacionDom: newAddress?.omitirValidacionDom || false,
    };

    const response = await postActualizarDomicilio({
      jsonBody: {
        usuarioOK: getCookie('usuarioOk'),
        folioPedido: getCookie('folioPedido'),
        ...domicilioEnvio,
      },
    });

    const { tipoMensaje = 'error', mensaje = '' } = response;

    setSessionMessage(mensaje);

    if (tipoMensaje === 'error') {
      if (mensaje === '498' || mensaje === '499') return false;
      setLoading(false);
      setAlertText(mensaje);
      setLoaddingAddress(false);
      setalertOpen(true);
      return false;
    }

    // handelDialog(true, mensaje, redirect);
    if (callback) await callback();
    else {
      setOrderData({
        ...orderData,
        domicilioEnvio,
      });
    }
    setLoading(false);

    setOpenAddress(false);
    setLoaddingAddress(false);

    return true;
  }

  useEffect(() => {
    getAddressesFunction();
  }, [getAddressesFunction]);

  return (
    (loading && <div>{t('getting')}</div>) || (
      <div className={`${styles.savedAddresses} ${styles[screenSize]}`}>
        <Alert open={alertOpen} setOpen={setalertOpen} title={'Terramar'} text={alertText} />
        <div className={styles.kitAddresses}>
          <div className={styles.addressTitle}>{t('address:myAddresses')}:</div>
          {addresses.map((val, key) => {
            const { address = '', outdoorNum = '', municipality = '', suburb = '' } = val;

            return (
              <div key={key} className={styles.address}>
                <div className={styles.addressData}>
                  <i
                    className={`material-icons-outlined ${styles.checkIcon}`}
                    onClick={() => {
                      setAddressSelected({ type: 'kit', pos: key, val });
                      handleSelect(val);
                    }}>
                    {(addressSelected.type === 'kit' &&
                      addressSelected.pos === key &&
                      'radio_button_checked') ||
                      'radio_button_unchecked'}
                  </i>
                  <div className={styles.addressContainer}>
                    <div className={styles.addressName}>
                      {orderData?.cliente?.nombreCompleto || ''}
                    </div>
                    <div className={styles.addressText}>
                      {address} {outdoorNum}, {municipality}, {suburb}
                    </div>
                  </div>
                </div>
                {/* <div className={styles.addressActions}>
                  <span className={`material-icons ${styles.addressIcon}`}>edit</span>
                  <span className={`material-icons-outlined ${styles.addressIcon}`}>delete</span>
                </div> */}
              </div>
            );
          })}
        </div>
        <div className={styles.clientAdresses}>
          <div className={styles.addressTitle}>{t('address:clientsAddresses')}:</div>
          {clientAddresses.map((val, key) => {
            const {
              address = '',
              outdoorNum = '',
              municipality = '',
              suburb = '',
              endCustName = '',
            } = val;
            return (
              <div key={key} className={styles.address}>
                <div className={styles.addressData}>
                  <i
                    className={`material-icons-outlined ${styles.checkIcon}`}
                    onClick={() => {
                      setAddressSelected({ type: 'client', pos: key, val });
                      handleSelect(val);
                    }}>
                    {(addressSelected.type === 'client' &&
                      addressSelected.pos === key &&
                      'radio_button_checked') ||
                      'radio_button_unchecked'}
                  </i>
                  <div className={styles.addressName}>{endCustName}</div>
                  <div className={styles.addressText}>
                    {address} {outdoorNum}, {municipality}, {suburb}
                  </div>
                </div>
                {/* <div className={styles.addressActions}>
                  <span className={`material-icons ${styles.addressIcon}`}>edit</span>
                  <span className={`material-icons-outlined ${styles.addressIcon}`}>delete</span>
                </div> */}
              </div>
            );
          })}
        </div>
      </div>
    )
  );
}
